"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecyclePageDataProvider = exports.useLifecyclePageDataContext = void 0;
const DataProviderCommonTypes_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/DataProviderCommonTypes");
const React = __importStar(require("react"));
const react_1 = require("react");
const isMounted_1 = __importDefault(require("src/hello_assets/src/components/system/isMounted"));
const CurrentProjectProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/CurrentProjectProvider");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const react_dom_1 = require("react-dom");
const react_router_dom_1 = require("react-router-dom");
const AppRouting_1 = require("src/hello_assets/src/components/system/AppRouting");
const LifecycleDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecycleDataProvider");
const LifecycleJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleJSONModel");
const LifecyclePageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageModelProvider");
const ProjectDashboardDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/dashboard/ProjectDashboardDataProvider");
const LifecycleGranularityJSONModel_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/model/LifecycleGranularityJSONModel");
const isFakeData = process.env.NODE_ENV === "development" && false;
const LifecyclePageDataContext = React.createContext(undefined);
const useLifecyclePageDataContext = () => {
    const context = React.useContext(LifecyclePageDataContext);
    if (!context) {
        throw new Error("useLifecyclePageDataContext must be used within a LifecyclePageDataContext.Provider");
    }
    return context;
};
exports.useLifecyclePageDataContext = useLifecyclePageDataContext;
const TEMP_FN = () => null;
const LifecyclePageDataProvider = (props) => {
    const isMounted = (0, isMounted_1.default)();
    const { projectApiKey } = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const lifecycleDataContext = (0, LifecycleDataProvider_1.useLifecycleDataContext)();
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    const [state, setState] = (0, react_1.useReducer)(
    // (state, newState) => ({...state, ...newState}),
    DataProviderCommonTypes_1.simpleFeatureReducer, lodash_1.default.cloneDeep(DataProviderCommonTypes_1.initialDataProviderState));
    const [urlState, setURLState] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), (0, LifecyclePageModelProvider_1.deserializeLifecycleJSONModelFromQueryString)(location.search).serialize());
    const serializedStateData = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        const compositeChartJSONModelFromURL = (0, LifecyclePageModelProvider_1.deserializeLifecycleJSONModelFromQueryString)(location.search);
        const serializedState = compositeChartJSONModelFromURL.serialize();
        const serializedStateChart = serializedState.chart;
        serializedState.chart = undefined;
        return {
            serializedState: serializedState,
            serializedStateChart: serializedStateChart
        };
    }, [location.search, TEMP_FN], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Change URL state only when ChartSettings changes.
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        const compositeChartJSONModel = (0, LifecyclePageModelProvider_1.deserializeLifecycleJSONModelFromQueryString)(location.search);
        setURLState(compositeChartJSONModel.serialize());
    }, [projectApiKey, serializedStateData.serializedStateChart, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Fetch data on page URL state change (!!! IMPORTANT: without ChartSettings !!!)
    ////////////////////////////////////////////////
    (0, use_custom_compare_1.useCustomCompareEffect)(() => {
        if (isMounted()) {
            (async () => {
                const compositeChartJSONModel = (0, LifecyclePageModelProvider_1.deserializeLifecycleJSONModelFromQueryString)(location.search);
                const lastNDays = compositeChartJSONModel.getPeriodDaysJSONModel().getLast();
                const granularity = compositeChartJSONModel.getGranularityJSONModel().getGranularity();
                (0, react_dom_1.unstable_batchedUpdates)(() => {
                    setState({ status: { inProgress: true } });
                });
                const newDataState = {};
                try {
                    let projectLifecycleResultByChunksFeatureState = await lifecycleDataContext.fetchLifecycle(lastNDays, granularity);
                    if (isFakeData) {
                        projectLifecycleResultByChunksFeatureState = (0, DataProviderCommonTypes_1.getFeatureStateFromICResult)({ ok: granularity === LifecycleGranularityJSONModel_1.Granularity.daily ? ProjectDashboardDataProvider_1.D_Lifecycle_Daily : ProjectDashboardDataProvider_1.D_Lifecycle_Weekly });
                    }
                    newDataState.error = {
                        error: undefined,
                        isError: false
                    };
                    newDataState.data = projectLifecycleResultByChunksFeatureState.state;
                }
                catch (e) {
                    newDataState.error = {
                        error: e,
                        isError: true
                    };
                }
                newDataState.status = {
                    loaded: true,
                    inProgress: false
                };
                (0, react_dom_1.unstable_batchedUpdates)(() => {
                    setURLState(compositeChartJSONModel.serialize());
                    setState(newDataState);
                });
            })();
        }
    }, [projectApiKey, serializedStateData.serializedState, isMounted], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Get URL JSON Model
    ////////////////////////////////////////////////
    const getURLJSONModel = (0, use_custom_compare_1.useCustomCompareCallback)(() => {
        return new LifecycleJSONModel_1.LifecycleJSONModel(urlState);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // On Chart Settings Changed
    ////////////////////////////////////////////////
    const onChartSettingsChanged = (0, use_custom_compare_1.useCustomCompareCallback)((chartSettings) => {
        const jsonModel = new LifecycleJSONModel_1.LifecycleJSONModel(urlState);
        jsonModel.getChartSettingsJSONModel().overwriteFromSerializedState(chartSettings);
        const serializedState = jsonModel.serialize();
        const newUrl = AppRouting_1.AppPathGenerator.Project.lifecycle(projectApiKey, serializedState);
        history.push(newUrl);
    }, [urlState], lodash_1.default.isEqual);
    ////////////////////////////////////////////////
    // Return value
    ////////////////////////////////////////////////
    const stateFns = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        getURLJSONModel,
        onChartSettingsChanged,
    }), [
        getURLJSONModel,
        onChartSettingsChanged,
    ], lodash_1.default.isEqual);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        state,
        urlState,
        stateFns,
    }), [
        state,
        urlState,
        stateFns,
    ], lodash_1.default.isEqual);
    return React.createElement(LifecyclePageDataContext.Provider, { value: value }, props.children);
};
exports.LifecyclePageDataProvider = LifecyclePageDataProvider;
